import { render } from "./bottoms.vue?vue&type=template&id=4cea38ef&scoped=true"
import script from "./bottoms.vue?vue&type=script&lang=js"
export * from "./bottoms.vue?vue&type=script&lang=js"

import "./bottoms.vue?vue&type=style&index=0&id=4cea38ef&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/carbon-space-admin-site-CI/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cea38ef"]])

export default __exports__